import { Big } from 'big.js';
import { DeliverableType } from '~common/model/Deliverable';
import { TenantOrderLine } from '~/lib/model';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import { PersonaType } from '~/tenants/common/TenantPersona';
import TwtJob from '~/tenants/twt/model/TwtJob';
import TwtNeighborhoodAmenityVideoConfig from '~/tenants/twt/performable/neighborhood-amenity-video/TwtNeighborhoodAmenityVideoConfig';

export const TWT_NEIGHBORHOOD_AMENITY_VIDEO_PRICE = 295;
export const TWT_NEIGHBORHOOD_AMENITY_VIDEO_PAYOUT = 250;

export class TwtNeighborhoodAmenityVideoJob extends TwtJob<typeof TwtNeighborhoodAmenityVideoConfig> {
  get performable() {
    return TwtNeighborhoodAmenityVideoConfig;
  }

  get deliverable(): DeliverableType {
    return DeliverableType.VIDEO;
  }

  get short(): string {
    return 'AMENITY';
  }

  get media(): PersonaType {
    return PersonaType.PROVIDER;
  }

  defaultValue(): ZodVersionedMetadata<(typeof TwtNeighborhoodAmenityVideoConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
    };
  }

  onsite(): number {
    if (this.order.metadata.transfer) {
      return 0;
    }

    return 60;
  }

  expenseLines(): TenantOrderLine[] {
    return [
      {
        amount: new Big(TWT_NEIGHBORHOOD_AMENITY_VIDEO_PAYOUT),
        description: this.performable.name,
        id: 'neighborhood_amenity_video',
      },
    ];
  }

  revenueLines(): TenantOrderLine[] {
    return [
      {
        amount: new Big(TWT_NEIGHBORHOOD_AMENITY_VIDEO_PRICE),
        description: this.performable.name,
        discountable: true,
        id: 'neighborhood_amenity_video',
        taxable: true,
      },
    ];
  }
}
